var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.243,
    height: 4.699,
    viewBox: "0 0 8.243 4.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate_6_",
    "data-name": "arrow-down-sign-to-navigate (6)",
    transform: "translate(-0.001 -97.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6066",
    "data-name": "Path 6066",
    d: "M4.122,101.839a.576.576,0,0,1-.408-.169L.17,98.126a.577.577,0,0,1,.816-.816l3.136,3.136L7.258,97.31a.577.577,0,0,1,.816.816L4.53,101.67A.576.576,0,0,1,4.122,101.839Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.abfc8d460dd7f772ffb676150dc0653e.svg";
export { ForwardRef as ReactComponent };